import React, { FC, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { GetListOfAllCob } from '../../list-of-lob/queries/all-cob-list';

export const ListOfCobDropDown: FC<{}> = () => {
  const allCobList = GetListOfAllCob();
  const history = useHistory();
  const [cobList, setCobList] = useState([
    { dcName: '', dcVtweg: '', divisionName: '', divisionSpart: '' },
  ]);

  const changeHandler = (e: any) => {
    const activeCob = 'activeCob';
    if (e.target.value === 'All') {
      localStorage.removeItem(activeCob);
      history.go(0);
    } else if (allCobList) {
      let selectedCobList: any[];
      const requiredKeys = ['dcVtweg', 'divisionSpart'];
      selectedCobList = allCobList.filter(
        list => list.dcName === e.target.value
      );
      selectedCobList = selectedCobList.map(coblist =>
        Object.assign({}, ...requiredKeys.map(key => ({ [key]: coblist[key] })))
      );
      localStorage.setItem(activeCob, JSON.stringify(selectedCobList));
      history.go(0);
    }
  };

  useEffect(() => {
    if (allCobList) {
      setCobList(allCobList);
    }
  }, [allCobList]);

  let userSelectedCob = '';
  if (localStorage.activeCob) {
    const getUserCob = JSON.parse(localStorage.activeCob);
    const getDcvtweg = getUserCob.map((i: any) => i.dcVtweg);
    if (allCobList) {
      userSelectedCob = allCobList
        .filter(item => item.dcVtweg === getDcvtweg.toString())
        .map(i => i.dcName)
        .toString();
    }
  }

  return (
    <select
      value={localStorage.activeCob ? userSelectedCob : 'All'}
      onChange={e => changeHandler(e)}
      style={{
        padding: '4px',
        border: '1px solid #ddd',
        borderRadius: '3px',
        width: '200px',
      }}
    >
      <option value="All"> All</option>
      {cobList.length > 0 &&
        cobList.map((list, index) => (
          <option key={index} value={list.dcName}>
            {list.dcName} ({list.dcVtweg}, {list.divisionSpart})
          </option>
        ))}
    </select>
  );
};
